angular
    .module('MyApp')
    .service('EditaisAssistenciaEstudantilService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.listarEditais = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/editais-assistencia-estudantil-vigentes',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarAnexos = function(idEdital){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/anexos-edital?id-edital=:idEdital',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idEdital
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarTipoAuxilios = function(idEdital){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/tipos-auxilio?idEdital=:idEdital',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idEdital
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarProcDocumentos = function(idProcesso){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/documentos-processo?processo=:idProcesso',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idProcesso
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.inscreverProjeto = function(projeto){
        let deferr = $q.defer();
        if (projeto) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/inscrever-se", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(projeto, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }


      this.listarValoresTipoPesquisa = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/valores-tipo-pesquisa',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarAnosLetivos = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/ano-letivo',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarPeriodosLetivos = function(ano){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/periodo-letivo?ano=:ano',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  ano
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarTipoAssistencia = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/tipo-assistencia',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarCategoriaAssistencia = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/categoria-assistencia',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }


      this.inscreverAssistencia = function(assistenciaDTO){
        let deferr = $q.defer();
        if (assistenciaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/inscrever-assistencia", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(assistenciaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  console.log(err);
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

    }]);
